export class Account {
    account_name: String;
}




// WEBPACK FOOTER //
// ./src/app/user/account.ts